import './Homepage.css';
import React, {useEffect, useState} from "react";

import headshot from './photos/headshot.webp';
import deck from './photos/deck.webp';
import PreviewManager from './PreviewManager';

function Homepage(props) {
  return (
    <div className="HP-container">
      <div className="HP-title">
        Welcome to Sam's HTM(a)A Fall 2023
      </div>
      <div className="HP-module">
        <div className="HP-subtitle">About Me</div>
        <div className="HP-flex">
          <div className="HP-body HP-half">
            My name is Sam Bruce and I'm a current senior here at MIT. I study Electrical Engineering and Computer Science, 
            and i'm really looking forward to using my skills as well as developing a whole host of new ones in this class. 
            <br />Growing up in Annapolis, MD I spent time in my home shop with my dad building all sorts of things ranging from home 
            improvements to school projects to any fun things I could think of. I spend most of my time outside of the classroom 
            on the water with the MIT varsity sailing team and I love anything to do with boats and the water. <br />Some of my 
            favorite projects I've done have related to my passion for sailing, including building a custom hydraulic trailer that 
            stored multiple boats and could collapse on itself to load/unload. Not as much fun was hours and hours of fiberglass and gel coat work 
            to fix any damage I caused on the water. <br />During the summer of 2020, I rebuilt a pool deck with my family, which was a 
            fun way to learn more about woodworking and large(r) scale construction. While I've had exposure to many of the concepts 
            we're learning in this class, I have had little to no formal training on most of it, so I'm very excited to learn a lot 
            this semester and be able to make (almost) anything.
          </div>
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={headshot} className="HP-photo"/>
              <div className="HP-caption">Me abroad for IAP last January</div>
            </div>
            <div className="HP-photoObject">
              <img src={deck} className="HP-photo"/>
              <div className="HP-caption">A deck I built over covid</div>
            </div>
          </div>
        </div>
      </div>
      <PreviewManager changePage={props.changePage} />
      
    </div>
  );
}

export default Homepage;